import { Component, forwardRef, Input} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ngx-mat-select-search',
  template: `
    <input
      class="mat-select-search-input"
      type="text"
      [disabled]="isDisabled"
      [placeholder]="placeholderLabel"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onTouched()"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()">
  `,
  styles: [`
    :host {
      background-color: inherit;
      display: block;
      max-width: 100%;
      min-width: 0;
      width: 100%;
    }

    .mat-select-search-input {
      appearance: none;
      background-color: inherit;
      border: 0;
      box-sizing: border-box;
      color: inherit;
      display: block;
      font: inherit;
      height: 48px;
      line-height: inherit;
      max-width: 100%;
      min-width: 0;
      outline: 0;
      padding: 0 16px;
      width: 100%;
    }

    .mat-select-search-input::placeholder {
      color: currentColor;
      opacity: 0.6;
    }
  `],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MatSelectSearchComponent),
    multi: true
  }],
  standalone: false
})
export class MatSelectSearchComponent implements ControlValueAccessor {
  @Input() placeholderLabel = '';
  @Input() noEntriesFoundLabel = '';

  value = '';
  isDisabled = false;

  private onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(onChange: (value: string) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: Event): void {
    this.value = (event.target as HTMLInputElement).value;
    this.onChange(this.value);
  }
}